<script lang="ts" module>
  import BaseBtn from '@/ui/base/BaseBtn.svelte';

  export interface LinkLoginButtonProps {
    label: string;
    onclick?: () => void;
    /** @deprecated use onclick */
    target?: () => void;
  }
</script>

<script lang="ts">
  let { label, onclick, target, ...props }: LinkLoginButtonProps = $props();
</script>

<BaseBtn {...props} onclick={onclick ?? target} class="font-sans text-sm font-normal text-c-link"
  >{label}</BaseBtn
>
